import { BreathingPanel } from "../components/BreathingPanel";
import { SiteFooter } from "../components/SiteFooter";
import { SiteHeader } from "../components/SiteHeader";
import { TeamSection } from "../components/TeamSection";
import { SITE_METADATA } from "../siteMetadata";

export function HomePage() {
  return (
    <div className="site-frame home-page">
      <SiteHeader />
      <main className="page-shell home-main">
        <section className="home-hero" aria-labelledby="hero-title">
          <div className="home-hero__copy">
            <h1 id="hero-title">{SITE_METADATA.headline}</h1>
            <p className="hero__summary">{SITE_METADATA.description}</p>
          </div>
          <BreathingPanel />
        </section>
        <TeamSection />
      </main>
      <SiteFooter />
    </div>
  );
}
